export const trackGrowth = (event, path = window.location.pathname) => {
  try {
    if (window.cbatGrowth) window.cbatGrowth.track(event, path);
    else (window.cbatGrowthQueue = window.cbatGrowthQueue || []).push([event, path]);
  } catch (_) { /* Analytics must never interrupt a session or saving its results. */ }
};
